import { auth } from './firebase';
import { onAuthStateChanged } from "firebase/auth";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRedirect from './AppRedirect';
import Login from './Login';
import Main from './Main/Main';
import Support from './Support';
import reportWebVitals from './reportWebVitals';

export function App() {
  const [user, setUser] = React.useState(null);
  const pathname = window.location.pathname.replace(/\/+$/, '') || '/';

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
    });
    return unsubscribe;
  }, []);

  if (pathname === '/support') {
    return <Support />;
  }

  if (pathname === '/app') {
    return <AppRedirect />;
  }

  if (!user) {
    return <Login />;
  }

  return <Main />;
}

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
